import * as z from "zod";
import { makeReportDateFilterSchema } from "./base-report-date-filter";
import { ReportFilterType } from "./report-filter-type";

export const OrderProcessedDateFilterSchema = makeReportDateFilterSchema(
  ReportFilterType.ORDER_PROCESSED_DATE,
);

export type OrderProcessedDateFilter = z.infer<
  typeof OrderProcessedDateFilterSchema
>;
